import { FC, useMemo } from 'react';
import { ICellRendererParams } from 'ag-grid-community';
import { transformToMapsLink } from '../../util/transform';

const CheckmateMapLinkRenderer: FC<ICellRendererParams> = (props: ICellRendererParams) => {
    const href = useMemo(() => {
        if (Array.isArray(props.value) && props.value.length) {
            return props.value.map((value) => {
                return transformToMapsLink(value);
            })
        }
        if (props.value) {
            return transformToMapsLink(props.value);
        }
        return '';
    }, [props.value]);
    return  <div className="line-break-cell">
        {Array.isArray(href) && href.map((innerRef, index) => {
            return <div key={index}><a href={innerRef} target={'_blank'}>{props.value[index]}</a><br/></div>
        })}
        {!Array.isArray(href) && !!href && <a href={href} target={'_blank'}>{props.value}</a>}
    </div>
};

export default CheckmateMapLinkRenderer